import { ContentCard } from "@msuite/ui/content-card";
import { icon } from "@msuite/ui/icons";
import { Loading } from "@msuite/ui/loading-screen";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { capitalize } from "@msuite/utils/strings";
import type { Enums } from "@msuite/utils/types";
import { client } from "@/hono";
import { ThirdPartyIntegrationActive } from "./third-party-integration-active";
import { ThirdPartyIntegrationNotActive } from "./third-party-integration-not-active";

/** Props Interface */
interface ThirdPartyIntegrationCardProps {
	integrationType: Enums<"integrationType">;
}

export function ThirdPartyIntegrationCard({ integrationType }: ThirdPartyIntegrationCardProps) {
	/** Hooks */

	/** Query */
	const { data, isLoading, refetch } = useQuery({
		queryKey: ["integration-state", integrationType],
		queryFn: async () => {
			const response = await client.integrations[":integrationType"].state.$get({
				param: { integrationType },
			});
			const data = await responseHandler(response);
			return data;
		},
	});

	/** Render */
	return (
		<ContentCard
			icon={icon("ToyBrick")}
			title={capitalize(integrationType)}
		>
			<Loading isLoading={isLoading}>
				<div>
					{data?.hasIntegration ? (
						<ThirdPartyIntegrationActive
							refetch={refetch}
							integrationType={integrationType}
							createdAt={data.createdAt}
						/>
					) : (
						<ThirdPartyIntegrationNotActive
							refetch={refetch}
							integrationType={integrationType}
						/>
					)}
				</div>
			</Loading>
		</ContentCard>
	);
}
